// extracted by mini-css-extract-plugin
export default {"GoKegg_app":"gokegg_GoKegg_app__4eZVu","GoKegg_Header":"gokegg_GoKegg_Header__wGQVB","GoKegg_Form":"gokegg_GoKegg_Form__nEnvu","GeneID":"gokegg_GeneID__8QKcf"};